// Page header configuration
// This file defines the header content for different routes in the application

export const pageHeaders = {
  dashboard: {
    title: "Integration Universe",
    subtitle: "Manage your API connections",
    showRequestButton: true
  },
  integrationDetail: (integrationName) => ({
    title: "Integration Universe",
    subtitle: `Manage your ${integrationName} integration`,
    showRequestButton: false
  }),
  settings: {
    title: "Settings",
    subtitle: "Manage your account and preferences",
    showRequestButton: false
  },
  activity: {
    title: "Activity",
    subtitle: "Monitor your integration activity and logs",
    showRequestButton: false
  },
  askOrbit: {
    title: "Ask Orbit",
    subtitle: "Query your connected APIs in plain English",
    showRequestButton: true
  },
  workflows: {
    title: "Workflows",
    subtitle: "Automate your business processes",
    showRequestButton: true
  },
  workflowNotifications: {
    title: "Notification Settings",
    subtitle: "Configure webhooks and subscribe to LexAI events",
    showRequestButton: true
  },
  profileSettings: {
    title: "Profile Settings",
    subtitle: "Manage your Orbit configuration",
    showRequestButton: true
  },
  companySettings: {
    title: "Company Settings",
    subtitle: "Manage your organization and team",
    showRequestButton: true
  },
  documentation: {
    title: "Documentation",
    subtitle: "Learn how to use Orbit integrations",
    showRequestButton: false
  }
};
